export const ApiReports = {
    get: params => ({
        url: '/reports',
        method: 'GET',
        params
    }),
    create: data => ({
        url: '/makeReport',
        method: 'POST',
        data
    }),
    delete: (id) => ({
        url: `/reports/${id}`,
        method: 'DELETE'
    }),
};